import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { User } from '../header/header.component';

@Injectable({
  providedIn: 'root',
})
export class CreateCaseService {
  constructor(private http: HttpClient) {}

  createCase(data) {
    return this.http.post('/case-mgmnt/cases', data);
  }

  checkHierarchy(data) {
    return this.http.post('/case-mgmnt/validateWorkflowMapping', data);
  }

  fromCaseCorrApi(data) {
    return this.http.post('/case-mgmnt/create-case-frm-corr', data);
  }

  getCombo(data) {
    return this.http.post('/worklist/get-combo-list', data);
  }

  getProfileData() {
    return this.http.get('/admin/my-profile');
  }
  methodForLoginDetails() {
    //fetch empid
    return this.http
      .get(/* '/admin/my-profile' */ `/admin/user-login-dtls`)
      .pipe(
        map(
          (response: { data: User; [key: string]: unknown }) => response?.data
        )
      );
  }
  getDepartmentList(data) {
    return this.http.post('/worklist/logged-in-user-departments', data);
  }
  getComboData(comboId: number | String, extraParams?) {
    let dataForPost = {
      ComboId: comboId.toString(),
    };
    if (extraParams) {
      dataForPost = { ...dataForPost, ...extraParams };
    }

    return this.http.post('/worklist/get-combo-list', dataForPost).pipe(
      map((response: any) => response?.data),
      catchError((error) => throwError(error))
    );
  }
  getSubjects(createCase) {
    return this.http.get('/case-mgmnt/subjects', {
      params: {
        unitId: createCase.get('role').value.optionValue,
        /* organizationId: createCase.get('department').value.optionValue,*/
        sectionId: createCase.get('section').value.optionValue,
      },
    });
  }
}
